// pages/CookiePolicy/index.jsx
import React, { useEffect } from "react";
import { Container } from "../../styles/components";
import {
	PolicyWrapper,
	PolicyHeader,
	PolicyContent,
	Section,
	SubSection,
} from "../PrivacyPolicy/styles"; // Reusing the styles
import useNavbar from "../../hooks/useNavbar";

const CookiePolicy = () => {
	const { setIsTransparent } = useNavbar();

	useEffect(() => {
		setIsTransparent(false);
		return () => setIsTransparent(true);
	}, [setIsTransparent]);

	return (
		<PolicyWrapper>
			<PolicyHeader>
				<Container>
					<h1>Cookie Policy</h1>
					<p>Last updated: January 19, 2025</p>
				</Container>
			</PolicyHeader>

			<Container>
				<PolicyContent>
					<Section>
						<h2>1. What Are Cookies?</h2>
						<p>
							Cookies are small text files that are placed on your device when
							you visit our website. They help provide you with a better, more
							personalized experience and help us improve our services.
						</p>
					</Section>

					<Section>
						<h2>2. Types of Cookies We Use</h2>

						<SubSection>
							<h3>2.1 Essential Cookies</h3>
							<p>
								These cookies are necessary for the website to function
								properly.
							</p>
							<ul>
								<li>Authentication and security</li>
								<li>Session management</li>
								<li>Basic functionality</li>
							</ul>
						</SubSection>

						<SubSection>
							<h3>2.2 Performance Cookies</h3>
							<p>Help us understand how visitors interact with our website.</p>
							<ul>
								<li>Analytics data</li>
								<li>Usage patterns</li>
								<li>Error reporting</li>
							</ul>
						</SubSection>

						<SubSection>
							<h3>2.3 Functionality Cookies</h3>
							<p>Remember your preferences and settings.</p>
							<ul>
								<li>Language preferences</li>
								<li>Login information</li>
								<li>Customization settings</li>
							</ul>
						</SubSection>
					</Section>

					<Section>
						<h2>3. How We Use Cookies</h2>
						<p>We use cookies for various purposes:</p>
						<ul>
							<li>Keeping you signed in</li>
							<li>Understanding how you use our website</li>
							<li>Improving our services</li>
							<li>Providing personalized content</li>
							<li>Ensuring website security</li>
						</ul>
					</Section>

					<Section>
						<h2>4. Managing Cookies</h2>
						<p>You can control and manage cookies in various ways:</p>

						<SubSection>
							<h3>4.1 Browser Settings</h3>
							<p>You can modify your browser settings to:</p>
							<ul>
								<li>Delete existing cookies</li>
								<li>Block new cookies</li>
								<li>Receive notifications about new cookies</li>
							</ul>
						</SubSection>

						<SubSection>
							<h3>4.2 Our Cookie Settings</h3>
							<p>
								You can adjust your cookie preferences through our cookie
								consent banner or settings panel on our website.
							</p>
						</SubSection>
					</Section>

					<Section>
						<h2>5. Third-Party Cookies</h2>
						<p>
							Some cookies are placed by third-party services that appear on our
							pages. We use these services to:
						</p>
						<ul>
							<li>Analyze site traffic</li>
							<li>Process payments</li>
							<li>Provide social media features</li>
						</ul>
					</Section>

					<Section>
						<h2>6. Cookie Duration</h2>
						<SubSection>
							<h3>6.1 Session Cookies</h3>
							<p>Temporary cookies that expire when you close your browser.</p>
						</SubSection>

						<SubSection>
							<h3>6.2 Persistent Cookies</h3>
							<p>
								Remain on your device for a set period or until you delete them
								manually.
							</p>
						</SubSection>
					</Section>

					<Section>
						<h2>7. Updates to This Policy</h2>
						<p>
							We may update this Cookie Policy from time to time. Any changes
							will be posted on this page with an updated revision date.
						</p>
					</Section>

					<Section>
						<h2>8. Contact Us</h2>
						<p>
							If you have any questions about our Cookie Policy, please contact
							us:
						</p>
						<ul>
							<li>Email: lepetitbylenscraft@gmail.com</li>
							<li>Phone: +94 77 771 5439</li>
							<li>Address: Maeliya, Ja-Ela, Sri Lanka.</li>
						</ul>
					</Section>
				</PolicyContent>
			</Container>
		</PolicyWrapper>
	);
};

export default CookiePolicy;
